import { EditorV3PositionClass } from "../classes/EditorV3Position";
import { EditorV3PositionF } from "../classes/interface";
import { getCaretPosition } from "./getCaretPosition";
import { getTextNodeAtOffset } from "./getTextNodeAtOffset";

/**
 * Set caret position in the editor.
 *
 * @param el - The editor element
 * @param pos - The position to set
 * @returns The resulting caret position or null
 */
export function setCaretPosition(
  el: HTMLDivElement,
  pos: EditorV3PositionClass,
): EditorV3PositionF | null {
  // Go to a lower line if required
  /* istanbul ignore else */
  if (
    el instanceof HTMLDivElement &&
    el.querySelectorAll("div.aiev3-line, div.aiev3-markdown-line").length > 0
  ) {
    const lines = el.querySelectorAll("div.aiev3-line, div.aiev3-markdown-line");
    /* istanbul ignore else */
    if (lines && pos.startLine < lines.length) {
      const f = getTextNodeAtOffset(lines[pos.startLine], pos.startChar);
      const l = getTextNodeAtOffset(lines[pos.endLine], pos.endChar);
      /* istanbul ignore else */
      if (f) {
        const range = document.createRange();
        range.setStart(f.node, f.offset);
        /* istanbul ignore else */
        if (l) {
          range.setEnd(l.node, l.offset);
        }
        const sel = window.getSelection();
        /* istanbul ignore else */
        if (
          sel &&
          document.contains(range.startContainer) &&
          document.contains(range.endContainer)
        ) {
          sel.removeAllRanges();
          // Text node between locked spans
          if (
            range.startOffset === 0 &&
            range.startContainer instanceof Text &&
            range.startContainer.parentElement instanceof HTMLDivElement &&
            range.startContainer.nextSibling instanceof HTMLSpanElement &&
            range.startContainer.nextSibling.classList.contains("is-locked") &&
            range.startContainer.previousSibling instanceof HTMLSpanElement &&
            range.startContainer.previousSibling.classList.contains("is-locked") &&
            range.startContainer.textContent === ""
          ) {
            range.startContainer.textContent = "\u200b";
          }
          if (
            range.endOffset === 0 &&
            range.endContainer instanceof Text &&
            range.endContainer.parentElement instanceof HTMLDivElement &&
            range.endContainer.nextSibling instanceof HTMLSpanElement &&
            range.endContainer.nextSibling.classList.contains("is-locked") &&
            range.endContainer.previousSibling instanceof HTMLSpanElement &&
            range.endContainer.previousSibling.classList.contains("is-locked") &&
            range.endContainer.textContent === ""
          ) {
            range.endContainer.textContent = "\u200b";
          }

          // Backwards selection
          if (pos.data.focusAt === "start") {
            sel.setBaseAndExtent(
              range.endContainer,
              range.endOffset,
              range.startContainer,
              range.startOffset,
            );
          }
          // Normal selection
          else {
            sel.addRange(range);
            /* istanbul ignore else */
            if (pos.isCollapsed) {
              sel.collapseToEnd();
            }
          }
        }
      }
      return getCaretPosition(el);
    }
  }
  return null;
}
